module.exports = __webpack_public_path__ + "media/images/blur-bg-f294f0fe7df99349dafe779d4b8c3074.jpg";